<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <rect fill="currentColor" x="3" y="1" width="18" height="8" rx="4"></rect>
    <rect fill="currentColor" x="3" y="12" width="18" height="3" rx="0.5"></rect>
    <rect fill="currentColor" x="3" y="16" width="18" height="3" rx="0.5"></rect>
    <rect fill="currentColor" x="3" y="20" width="18" height="3" rx="0.5"></rect>
</svg>
